// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2EVN7","text":"SelectPayment_text__1Ngmk","title":"SelectPayment_title__1tD4F","btn":"SelectPayment_btn__3_pAP"};